import React, { useState, useEffect, useCallback, useContext } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { BUSINESS_PROMOTIONS } from '../../config/config';
import { API } from '../../api/API';
import { extractError } from '../../api/ErrorUtil';
import { FormField } from '../../uiwidgets/FormField';
import { FormContainer } from '../../uiwidgets/FormContainer';
import { SubmitButton } from '../../uiwidgets/SubmitButton';
import { CancelButton } from 'uiwidgets/CancelButton';
import { Row, Col, Card } from 'react-bootstrap';
import {
    isValidUUID, isPostalCodeValid, containsAlphabetsOnly,
    validAddress, containsAlphaNumAndSpaceOnly
} from 'util/Validators';
import { NewButton as AppButton } from './../../uiwidgets/NewButton';
import _ from "lodash";
import ProvinceSelect from 'uiwidgets/ProvinceSelect';
import PostalCode from 'uiwidgets/PostalCode';
import CountrySelect from 'uiwidgets/CountrySelect';


const UserPromotionPage = () => {

    const initialState = {
        errors: {},
        infoMessage: "",
        promotionImage: {},
        readOnly: false,
        editMode: false,
        randImageId: "",
        address: "",
        city: "",
        state: "ON",
        country: "CA",
        zip: "",
        formSubmitted: false

    }
    const initialValidationState = {
        promotionImageErrMsg: "",
        promotionImageError: false,
        addressErrMsg: "",
        addressError: false,
        cityErrMsg: "",
        cityError: false,
        stateErrMsg: "",
        stateError: false,
        countryErrMsg: "",
        countryError: false,
        zipErrMsg: "",
        zipError: false,
        isFormValid: true

    }

    const requestParams = useParams();
    const [promotionFulfilment, setPromotionFulfilment] = useState({});
    const [optionMap, setOptionMap] = useState([]);
    const [promotionImages, setPromotionImages] = useState([]);
    const [promotion, setPromotion] = useState({});
    const [formData, setFormData] = useState({});
    let [formValidityData, setFormValidityData] = useState(initialValidationState);
    const navigate = useNavigate();


    const fetchPromotions = useCallback(async () => {
        try {
            let promotionResponse = await API.get(BUSINESS_PROMOTIONS + "/user-promotion-fulfilment/" + requestParams.promotionId);
            let promotionFulfilment = promotionResponse.data

            setPromotionFulfilment(promotionFulfilment);
            const optionMap = promotionFulfilment.promotion.promotionOptions.reduce((map, option) => {
                const { id, optionName, value } = option;

                if (!map[optionName]) {
                    map[optionName] = []; // Initialize the array if not present
                }
                map[optionName].push({ id, value }); // Add value to the list

                return map;
            }, {});

            setOptionMap(optionMap);
            setPromotion(promotionFulfilment.promotion);
            setPromotionImages(promotionFulfilment.promotion.promotionImages);
            setFormData(initialState);


        } catch (error) {
            let { message, errors, httpStatus } = extractError(error);
            if (httpStatus === 404) {
                setPromotionFulfilment({});
                setFormData({ ...formData, readOnly: true, infoMessage: "No promotions were found" });
            } else {
                setFormData({ ...formData, readOnly: true, errors: { message, errors, httpStatus } });
            }
        }

    });

    useEffect(() => {
        fetchPromotions();
    }, []);

    const messageReset = () => {
        return {
            infoMessage: "",
            errors: {}
        }
    }

    const onToastClose = () => {
        setFormData({
            ...formData,
            ...messageReset()
        });
    }

    const handleCountryChange = (event) => {
        const name = event.target.name;
        const value = event.target.value;
        let defaultState = "ON";
        if (value === "US") {
            defaultState = "MI";
        }
        setFormData({
            ...formData,
            [name]: value,
            state: defaultState
        });
    }

    const handleChange = async (event, optionName) => {
        const name = event.target.name;
        const value = event.target.value;
        let state = { ...formData };

        if (!_.isEmpty(optionName)) {
            state[optionName] = value;
        } else if (name === 'promotionImage') {
            //go thru promotion images and get the promotion image 
            //which matches the id
            const promoImage = promotionImages.filter(promoImg => promoImg.id == value);
            state.promotionImage = promoImage[0];
        } else {
            state[name] = value;
        }
        setFormData({
            ...state
        })
    }

    const handleValidation = async (event, optionName) => {
        const name = event.target.name;
        const value = event.target.value;
        let state = { ...formValidityData }
        if (!_.isEmpty(optionName)) {
            let { hasError, error } = validate('option', value, optionName);
            state[optionName + 'Error'] = hasError;
            state[optionName + 'ErrMsg'] = error;
        } else {
            let { hasError, error } = validate(name, value);
            state[name + 'Error'] = hasError;
            state[name + 'ErrMsg'] = error;
        }

        setFormValidityData({
            ...state
        })

    }

    const validate = (name, value, optionName) => {
        let hasError = false,
            error = ""

        switch (name) {
            case "option":
                if (value.trim() === "") {
                    hasError = true
                    error = optionName + " cannot be empty"
                } else if (!isValidUUID(value)) {
                    hasError = true
                    error = optionName + " is invalid"
                }
                else {
                    hasError = false
                    error = ""
                }
                break;
            case "promotionImage":
                if (value.trim() === "") {
                    hasError = true
                    error = "Image Name cannot be empty"
                } else if (!isValidUUID(value)) {
                    hasError = true
                    error = "Image is invalid"
                }
                else {
                    hasError = false
                    error = ""
                }
                break;
            case "address":
                if (value.trim() === "") {
                    hasError = true
                    error = "Address name cannot be empty"
                } else if (!validAddress(value)) {
                    hasError = true
                    error = "Invalid Address. Avoid Special characters"
                } else {
                    hasError = false
                    error = ""
                }
                break
            case "city":
                if (value.trim() === "") {
                    hasError = true
                    error = "City name cannot be empty"
                } else if (!containsAlphaNumAndSpaceOnly(value)) {
                    hasError = true
                    error = "Invalid City. Only alpha-numeric characters are allowed";
                } else {
                    hasError = false
                    error = ""
                }
                break
            case "state":
                if (value.trim() === "") {
                    hasError = true
                    error = "State name cannot be empty"
                } else if (!containsAlphaNumAndSpaceOnly(value)) {
                    hasError = true
                    error = "Invalid State. Only alpha-numeric characters are allowed"
                } else {
                    hasError = false
                    error = ""
                }
                break
            case "country":
                if (value.trim() === "") {
                    hasError = true
                    error = "Country name cannot be empty"
                } else if (!containsAlphabetsOnly(value)) {
                    hasError = true
                    error = "Invalid Country. Only alpha characters are allowed"
                } else {
                    hasError = false
                    error = ""
                }
                break
            case "zip":
                if (value.trim() === "") {
                    hasError = true
                    error = "Postal Code cannot be empty"
                } else if (!isPostalCodeValid(value, formData.country)) {
                    hasError = true
                    error = "Invalid Postal Code"
                } else {
                    hasError = false
                    error = ""
                }
                break

            default:
                break;
        }
        return { hasError, error };
    }

    const validateFullForm = (event) => {
        let state = { ...formValidityData };
        let isFormValid = true;
        let hasError = false, error = "";

        for (let i = 0; i < event.target.getElementsByTagName('input').length; i++) {
            let fieldName = event.target.getElementsByTagName('input')[i].name;
            let fieldValue = event.target.getElementsByTagName('input')[i].value;
            const { hasError, error } = validate(fieldName, fieldValue);
            state[fieldName + 'Error'] = hasError;
            state[fieldName + 'ErrMsg'] = error;
            if (hasError) {
                isFormValid = false;
            }


        }

        for (let i = 0; i < event.target.getElementsByTagName('select').length; i++) {
            let fieldName = event.target.getElementsByTagName('select')[i].name;
            let fieldValue = event.target.getElementsByTagName('select')[i].value;

            let optionName = Object.keys(optionMap).filter(optionName => optionName === fieldName)
            if (!_.isEmpty(optionName)) {
                let valResult = validate('option', fieldValue, optionName[0]);
                hasError = valResult.hasError;
                error = valResult.error
                state[optionName + 'Error'] = hasError;
                state[optionName + 'ErrMsg'] = error;
            } else {
                let valResult = validate(fieldName, fieldValue);
                hasError = valResult.hasError;
                error = valResult.error
                state[fieldName + 'Error'] = hasError;
                state[fieldName + 'ErrMsg'] = error;
            }
            if (hasError) {
                isFormValid = false;
            }
        }

        setFormValidityData({
            ...state
        });
        return isFormValid;

    }

    const createOptionValueList = (optionMap, objectData) => {
        const list = [];

        // Iterate over each key in the optionMap
        for (const key in optionMap) {
            const options = optionMap[key];
            const selectedId = objectData[key];

            // Find the matching entry in the optionMap for the selected ID
            const selectedOption = options.find(option => option.id === selectedId);

            if (selectedOption) {
                list.push({
                    optionName: key,
                    id: selectedId,
                    value: selectedOption.value
                });
            }
        }

        return list;
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        //validate full form. All fields are required
        const isFormValid = validateFullForm(event);
        //first check if there are validation errors
        if (!isFormValid) {
            alert("Form has validation errors");
            return false;
        }

        //puti n format of the PromotionUserChoceDTO
        let promotionOptions = createOptionValueList(optionMap, formData);
        let promotionImage = _.isEmpty(formData.promotionImage)?null: formData.promotionImage

        let promotionUserChoice = {
            promotionOptions,
            promotionImage,
            address: formData.address,
            city: formData.city,
            state: formData.state,
            zip: formData.zip,
            country: formData.country
        }

        try {
            let promotionResponse = await API.put(BUSINESS_PROMOTIONS + "/user-promotion-fulfilment/" + requestParams.promotionId, promotionUserChoice);
            setFormData({ ...formData, readOnly: true, formSubmitted:true, infoMessage: "Promotion was successfully submitted" });
        } catch (error) {
            let { message, errors, httpStatus } = extractError(error);
            if (httpStatus === 404) {
                setFormData({ ...formData, infoMessage: "Promotion was not found" });
            } else {
                setFormData({ ...formData, errors: { message, errors, httpStatus } });
            }
        }

    }

    const handleCancel = async (event) => {
        navigate("/home");

    }

    return (
        <React.Fragment>
            <FormContainer title="Claim your gift" submitButtonFunction={handleSubmit}
                errors={formData.errors} infoMessage={formData.infoMessage} toastCloseFunc={onToastClose}>
                { !formData.formSubmitted && <React.Fragment><Row>
                    <Col mb={8} lg={8} sm={12}>
                        <Row>
                            <Col mb={12} lg={12} sm={12}>
                                {promotion.name}
                            </Col>
                        </Row>
                        <Row>
                            <Col mb={12} lg={12} sm={12}>
                                {promotion.description}
                            </Col>
                        </Row>
                        <Row>
                            <Col mb={12} lg={12} sm={12}>Select the options below and click on submit to claim your gift.</Col>
                        </Row>
                        <Row>
                            <Col mb={8} lg={8} sm={12}>
                                {optionMap && Object.keys(optionMap).map((optionName, idx) => (
                                    <React.Fragment key={idx}>
                                        <FormField id={optionName}
                                            name={optionName}
                                            label={optionName}
                                            type="select"
                                            readOnly={formData.readOnly}
                                            onChange={event => handleChange(event, optionName)}
                                            onBlur={event => handleValidation(event, optionName)}
                                            value={formData[optionName]}
                                            valstate={!formValidityData[optionName + 'Error']}
                                            valMsg={formValidityData[optionName + 'ErrMsg']}>
                                            <React.Fragment>
                                                <option value="" key="zeroval"></option>
                                                {optionMap[optionName] && optionMap[optionName].map((optionData, idx) => (
                                                    <option key={idx} value={optionData.id}>
                                                        {optionData.value}
                                                    </option>
                                                ))}
                                            </React.Fragment>
                                        </FormField>
                                    </React.Fragment>

                                ))}
                            </Col>
                        </Row>
                        <Row>
                            <Col mb={8} lg={8} sm={12}>
                             {!_.isEmpty(promotionImages) && <FormField id="promotionImage"
                                    name="promotionImage"
                                    label="Select the Image"
                                    type="select"
                                    readOnly={formData.readOnly}
                                    onChange={event => handleChange(event)}
                                    onBlur={event => handleValidation(event)}
                                    value={formData?.promotionImage?.id}
                                    valstate={!formValidityData.promotionImageError}
                                    valMsg={formValidityData.promotionImageErrMsg}>
                                    <React.Fragment>
                                        <option value="" key="zeroval"></option>
                                        {!_.isEmpty(promotionImages) && promotionImages.map((promotionImage, idx) => (
                                            <option key={idx} value={promotionImage.id}>
                                                {promotionImage.imageName}
                                            </option>
                                        ))}
                                    </React.Fragment>
                                </FormField>}
                            </Col>

                        </Row>
                    </Col>
                    <Col>
                        {formData.promotionImage && formData.promotionImage.mediaType && <Card.Img src={process.env.REACT_APP_BASE_API_URL + BUSINESS_PROMOTIONS
                            + '/' + promotion.promotionId + '/img/' + formData.promotionImage.id}
                            style={{ height: '250px', width: '200px', objectFit: 'cover' }} />}

                    </Col>
                </Row>
                <Row>
                    <Col>&nbsp;</Col>
                </Row>
                <Row>
                    <Col><h6>Shipping Address</h6></Col>
                </Row>
                <Row>
                    <Col>
                        <FormField name="address" label="Address" type="text" value={formData.address}
                            placeholder="Address" onChange={handleChange} onBlur={handleValidation}
                            valstate={!formValidityData.addressError} valMsg={formValidityData.addressErrMsg}
                            readOnly={formData.readOnly} />
                    </Col>
                </Row>
                <Row>
                    <Col mb={2} lg={2} sm={6}>
                        <CountrySelect name="country" onChange={handleCountryChange} onBlur={handleValidation}
                            valstate={!formValidityData.countryError} valMsg={formValidityData.countryErrMsg}
                            readOnly={formData.readOnly} value={formData.country} />
                    </Col>
                    <Col mb={4} lg={4} sm={6}>
                        <ProvinceSelect name="state" onChange={handleChange} onBlur={handleValidation}
                            valstate={!formValidityData.stateError} valMsg={formValidityData.stateErrMsg}
                            readOnly={formData.readOnly} value={formData.state} country={formData.country} />
                    </Col>
                </Row>
                <Row>
                    <Col mb={6} lg={6} sm={12}>
                        <FormField name="city" label="City" type="text" value={formData.city}
                            placeholder="City" onChange={handleChange} onBlur={handleValidation}
                            valstate={!formValidityData.cityError} valMsg={formValidityData.cityErrMsg}
                            readOnly={formData.readOnly} />
                    </Col>
                    <Col mb={5} lg={5} sm={12}>
                        <PostalCode name="zip" label="Postal Code" type="text" value={formData.zip}
                            placeholder="Postal Code" onChange={handleChange} onBlur={handleValidation}
                            valstate={!formValidityData.zipError} valMsg={formValidityData.zipErrMsg}
                            readOnly={formData.readOnly} country={formData.country} />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <SubmitButton label='Save Promotion' disabled={formData.readOnly} className="me-4" />
                        {!formData.readOnly && <CancelButton label='Cancel' onClick={handleCancel} />}
                        {formData.readOnly && <AppButton label='Return to Home Page' onClick={handleCancel} />}
                    </Col>

                </Row> </React.Fragment>}
                { formData.formSubmitted && <React.Fragment>
                    Your gift claim for the promotion:"{promotion.name}" was successfully submitted. The gift will be mailed to you. 
                    You may call/email the HOPE admin to find the status of the shipment.<br/>
                    <AppButton label='Return to Home Page' onClick={handleCancel} />
                    </React.Fragment>}
            </FormContainer>
        </React.Fragment>
    )
}

export default UserPromotionPage